<bolt-header>
        <div slot="logo">
            <bolt-logo href="{{environment.NATIONWIDE.HOME}}"
                class="bolt-header-desktop-only"></bolt-logo>
            <bolt-logo href="{{environment.NATIONWIDE.HOME}}"
                class="bolt-header-mobile-only"
                type="nw-mark"></bolt-logo>
        </div>
        <ul slot="utility-links">
            @if (showProfileButton) {
            <li><a href="{{ getProfileLink() }}">Profile</a></li>
            }
            @if (showClaimsButton) {
            <li><a  href="{{ getClaimsLink() }}"  target="_blank"
                rel="noopener">Claims</a></li>
            }
            @if (showGetHelpButton) {
            <li><a href="javascript:void(0)"
                    onclick="window.helpModal.openModal()">Get help</a></li>
            }
        </ul>
        <div slot="main-actions">
            @if (showLogoutButton) {
            <bolt-button slot="forward"
                arialabel="Log out"
                class="bolt-header-desktop-only"
                color="darkMint"
                (click)="onLogoutClick()">Log out</bolt-button>
            <bolt-button
                arialabel="Log out"
                size="sm"
                class="bolt-header-mobile-only"
                color="darkMint"
                (click)="onLogoutClick()">Log out</bolt-button>
            }

        </div>

    </bolt-header>

    <bolt-modal id="helpModal"
        heading="Get help">
        <a href="{{environment.NATIONWIDE.nwFaq}}"
            target="_blank"
            rel="noopener">Frequently Asked Questions -
            Nationwide<br></a>
        <p>Claims call center <a class="phone-number"
                href="tel:1-800-421-3535">1-800-421-3535</a><br></p>
        <a href="{{environment.NATIONWIDE.agency}}"
            target="_blank"
            rel="noopener">Find an agent<br></a>
    </bolt-modal>
